import Vue from 'vue';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { date } from 'devexpress-dashboard/model/index.metadata';

export default {
  name: 'Hyperlinks',
  components: {
    /*HyperlinkComp: require('./hyperlink.vue').default,*/
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      hyperlinks: [],
      bConfirmDialog: false,
      deleteConfirmMessage: '',
      editingHyperlink: {

      },
      message: '',
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_jobcard_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.dataObj.appData.hyperlinks.forEach(p => {
          if (!p.uuid || p.uuid.length === 0)
            p.uuid = uuidv4();
        });
        this.hyperlinks = this.dataObj.appData.hyperlinks;
      });
    },
    processLinks(event) {
      console.log(event.target.files);
      if (event.target.files.length === 0)
        return;

      event.target.files.forEach(item => {
        var hyperLink = {
          id: 0,
          fileName: item.name,
          uuid: uuidv4()
        };
        this.hyperlinks.push(hyperLink);
      });
      this.dataObj.appData.hyperlinks = this.hyperlinks;
    },
    addHyperlink() {
      var iCntrl = document.getElementById('upload');
      iCntrl.click();
    },
    removeConfirm(item) {
      this.deleteConfirmMessage = this.$t('attachments.DeleteHyperlink') + ' [' + item.fileName + '] ?';
      this.editingHyperlink = item;
      this.bConfirmDialog = true;
    },
    removeHyperlink() {
      this.dataObj.appData.hyperlinks = this.dataObj.appData.hyperlinks.filter(p => p.uuid !== this.editingHyperlink.uuid);
      this.hyperlinks = this.dataObj.appData.hyperlinks;
    },
    closeDialog() {
      this.bHyperlinkDialog = false;
    },
  },
  
}

